import React, { ReactElement, ReactNode } from 'react';
import { DeviceType } from 'shared/models/device-type';

import LinkableDevice from 'features/device/linkable-device/domain/models/linkable-device';
import { DeviceLinkContext } from 'features/device/providers/device-link-provider/device-link-context';
import { IDeviceLinkContextProviderHooks, useDeviceLinkContextProviderHooks } from 'features/device/providers/device-link-provider/hooks';

interface IProps {
  children: ReactNode;
  organisationUnitId: string;
  devicesToHide: LinkableDevice[];
  transmitterResidentSettings?: DeviceType[];
}

export const DeviceLinkProvider = (props: Readonly<IProps>): ReactElement => {
  const { children, organisationUnitId, devicesToHide, transmitterResidentSettings } = props;
  const hooks = useDeviceLinkContextProviderHooks({ organisationUnitId, devicesToHide, transmitterResidentSettings });

  return <DeviceLinkContext.Provider value={hooks}>{children}</DeviceLinkContext.Provider>;
};

export const useDeviceLinkContextProvider = (): IDeviceLinkContextProviderHooks =>
  React.useContext<IDeviceLinkContextProviderHooks>(DeviceLinkContext);
